module.exports = "<div class=\"room-gallery__header\">\n  <div class=\"title\">{{ unitType.name }}</div>\n  <div class=\"room-label\">Sleeps {{ unitType.adultOccupancy + ' Adults' }}</div>\n</div>\n<div class=\"room-gallery__inner\">\n  <offset-swiper [slides]=\"images\"></offset-swiper>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/room-availability/room-gallery/room-gallery.component.html
// module id = ../../../../../src/app/room-availability/room-gallery/room-gallery.component.html
// module chunks = main